/* Furniva — the home page's arrival motion (furniva-home-refresh.css).

   1. Each section that starts below the first screen is marked .fv-rise and
      rises in once, when a fifth of it has come into view; the cards inside
      a rail follow a beat apart. Sections already on screen at load are left
      alone, so nothing that is visible ever disappears to be animated back.

   2. The home page has no scroll arrows. Instead, each row that actually
      has more to show nudges once — the cards lean left and settle back —
      the first time most of it is in view, after it has risen in. A row that
      fits, or one someone has already scrolled, is left still.

   Nothing happens for reduced motion or without IntersectionObserver. */
(function () {
  'use strict';
  var main = document.querySelector('main[data-template="index"]');
  if (!main || !('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ------------------------------------------------------------- 1. rise -- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

  // Every section is measured first and marked afterwards. Marking one between
  // measurements made the browser lay the whole page out again for the next
  // read — about 300ms of forced layout on a phone (PageSpeed, 2026-10-13).
  var fold = window.innerHeight;
  var below = Array.prototype.filter.call(main.children, function (section) {
    if (!section.classList || !section.classList.contains('shopify-section')) return false;
    var r = section.getBoundingClientRect();
    return r.height !== 0 && r.top >= fold;
  });
  below.forEach(function (section) {
    section.classList.add('fv-rise');
    io.observe(section);
  });

  /* ------------------------------------------------------------ 2. nudge -- */
  function nudge(row) {
    if (row.scrollLeft > 4 || row.scrollWidth <= row.clientWidth + 8) return;
    row.classList.add('is-nudging');
    setTimeout(function () { row.classList.remove('is-nudging'); }, 1600);
  }
  var nio = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      nio.unobserve(entry.target);
      var section = entry.target.closest('.shopify-section');
      // Let a rising section settle first, so the two movements do not overlap.
      var wait = section && section.classList.contains('fv-rise') ? 1100 : 500;
      setTimeout(function () { nudge(entry.target); }, wait);
    });
  }, { threshold: 0.6 });
  main.querySelectorAll('[data-fv-rail], [data-fv-nudge]').forEach(function (row) {
    if (row.closest('[data-fv-concierge]')) return; // it has its own
    nio.observe(row);
  });
})();

/* Shop the look — several looks in one row (sections/furniva-shop-look.liquid):
   room tabs, arrows and dots follow the row as it is swiped or stepped. */
(function () {
  'use strict';
  document.querySelectorAll('[data-fv-looks]').forEach(function (root) {
    var track = root.querySelector('[data-fv-look-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-fv-look-slide]'));
    if (!track || slides.length < 2) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-fv-look-tab]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-fv-look-dot]'));
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function current() {
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0;
      slides.forEach(function (s, i) { if (s.offsetLeft - track.offsetLeft <= mid) best = i; });
      return best;
    }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }
    function paint() {
      var i = current();
      tabs.forEach(function (t, n) { t.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
    }
    tabs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
    var prev = root.querySelector('[data-fv-look-prev]');
    var next = root.querySelector('[data-fv-look-next]');
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    var raf = 0;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(paint); }, { passive: true });
  });
})();
